import React from "react";
import { Route, Switch } from "react-router-dom";

import HeaderLine from "./components/HeaderLine";
import MenuLine from "./components/MenuLine";
import Landing from "./components/Landing";
import Footer from "./components/Footer";
import ProductList from "./components/ProductList";
import ProductDetails from "./components/ProductDetails";
import Contacts from "./components/Contacts";
import Partners from "./components/Partners";
import About from "./components/About";
import Profile from "./components/Profile";
import Register from "./components/Register";
import Gallery from "./components/Gallery";
import UserCart from "./components/Cart";
import LegalPage from "./components/LegalPage";

const Routes: React.FC = () => {

  return (
    <div className="app-shell">
      <HeaderLine />
      <MenuLine />
      <main className="app-content">
        <Switch>
          <Route exact path="/contacts"
            render={() => (
              <Contacts />
            )}
          />
          <Route exact path="/gallery"
            render={() => (
              <Gallery />
            )}
          />
          <Route exact path="/privatuma-politika"
            render={() => (
              <LegalPage type="privacy" />
            )}
          />
          <Route exact path="/sikdatnes"
            render={() => (
              <LegalPage type="cookies" />
            )}
          />
          <Route exact path="/partners"
            render={() => (
              <Partners />
            )}
          />
          <Route exact path="/about"
            render={() => (
              <About />
            )}
          />
          <Route exact path="/profile"
            render={() => (
              <Profile />
            )}
          />
          <Route exact path="/profile/:tab"
            render={(match) => (
              <Profile tab={match.match.params.tab} />
            )}
          />
          <Route exact path="/profile/:tab/:operation"
            render={(match) => (
              <Profile
                tab={match.match.params.tab}
                operation={match.match.params.operation}
              />
            )}
          />
          <Route exact path="/become-client"
            render={() => (
              <Register />
            )}
          />
          <Route exact path="/cart"
            render={() => (
              <UserCart />
            )}
          />
          <Route
            exact path="/product/category/:id"
            render={(match) => (
              <ProductList type="category" id={match.match.params.id} />
            )}
          />
          <Route
            exact path="/product/:id"
            render={(match) => (
              <ProductDetails type="id" id={match.match.params.id} />
            )}
          />
          <Route exact path="/"
            render={() => (
              <Landing />
            )}
          />
        </Switch>
      </main>
      <Footer />
    </div>
  )
};

export default Routes;
